import ApiService from "@/common/api.service";
import {API_OMS_URL} from "@/common/config";

const FileService = {
    save(code, type, filter = {}, additional = {}){
        return ApiService.post(API_OMS_URL+'/files', {code : code, type : type, filter : filter, additional : additional}, {
            headers: ApiService.getHeader(),
            responseType : 'blob'
        })
    },
    load(code, type, additional = {}){
        return ApiService.post(API_OMS_URL+'/files', {code : code, type : type, filter : {}, additional : additional}, {
            headers: ApiService.getHeader()
        })
    },
    loadPdf(code, filter = {}, additional = {}){
        return ApiService.post(API_OMS_URL+'/files', {code : code, type : 'pdf', filter : filter, additional : additional}, {
            headers: ApiService.getHeader()
        })
    }
}

export default FileService;